<template>
  <div class="quick-start-container">
    <v-card class="quick-start-card elevation-11">
      <v-row
        no-gutters
        class="d-flex justify-center align-center quick-start-content"
      >
        <v-col cols="auto">
          <v-card-text class="text-uppercase quick-access-text">
            <span>Get quick access to:</span>
          </v-card-text>
        </v-col>
        <v-col
          v-for="(obj, index) in titles"
          cols="auto"
          @click="linkClicked(obj['routeName'])"
        >
          <v-card-text class="get-started-text">
            <div class="span-div">
              <span class="quickstart-cta"
                >{{ obj["title"] }}
                <v-icon
                  class="ml-3 quickstart-icon"
                  :class="titles.length > 1 ? 'hidden-icon' : ''"
                  >{{ icons.mdiArrowRight }}</v-icon
                >
              </span>
            </div>
            <div
              v-if="index < titles.length - 1 && !hasCallout"
              class="quick-start-divider"
            ></div>
          </v-card-text>
          <div v-if="index < titles.length - 1" class="hr-divider hidden"></div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mdiArrowRight } from "@mdi/js";
export default {
  name: "QuickAccess",
  data() {
    return {
      icons: {
        mdiArrowRight: mdiArrowRight,
      },
    };
  },
  props: {
    hasCallout: {
      required: true,
      default: false,
      type: Boolean,
    },
    titles: {
      required: true,
      default: [],
      type: Array,
    },
  },
  methods: {
    linkClicked(routeName) {
      this.$emit("quickStartCardLinkClicked", routeName);
    },
  },
};
</script>

<style lang="scss" scoped>
.quick-start-container {
  width: 100%;
  margin-top: -30px;
  position: relative;
  z-index: 15;

  .hidden-icon {
    display: none;
  }

  .quick-start-card {
    font-family: Montserrat;
    width: fit-content;
    margin-left: 77px;
    padding: 25px 40px;
    z-index: 12;
    * {
      padding: 0;
    }

    .get-started-text {
      padding-left: 30px;
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      color: #282828;
      cursor: pointer;
      display: flex;
      flex-direction: row;
      align-items: center;

      .quick-start-divider {
        margin-left: 30px;
        width: 1px;
        height: 32px;
        background-color: #f1f2f2;
      }
    }
  }
  .quick-access-text {
    font-size: 11px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 1.8px;
    color: #747474;
  }

  a {
    text-decoration: none !important;
    color: inherit;
  }
  .quickstart-cta {
    &:hover {
      text-shadow: 0.3px 0.3px 0 rgba(40, 40, 40, 0.7),
        -0.3px -0.3px 0 rgba(40, 40, 40, 0.7);
      -webkit-text-stroke: 1px rgba(40, 40, 40, 0.7);

      &::v-deep .v-icon__svg {
        fill: #282828 !important;
      }
    }
  }
}

@media only screen and (min-width: 0px) and (max-width: 807px) {
  .quick-start-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .hidden-icon {
      display: inline-block;
    }

    .quick-start-card {
      margin-left: inherit;
      min-width: 303px;
      align-items: start !important;
      padding: 24px;

      .quick-access-text {
        margin-bottom: 24px;
      }

      .quick-start-divider {
        display: none;
      }

      .get-started-text {
        padding-left: 0;
      }

      .quick-start-content {
        align-items: start !important;
        flex-direction: column;
        width: 100%;

        .col-auto {
          width: 100%;

          .hr-divider {
            display: block;
            width: 100%;
            height: 1px;
            background-color: #f1f2f2;
            margin-bottom: 16px;
          }
        }

        .span-div {
          margin-bottom: 19px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .span-div:last-child {
          margin-bottom: 0px;
        }
      }
    }
  }
}
</style>
